/* eslint-disable no-nested-ternary,no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define */

import { EVENTS } from '../../../../app/constants/events';
import { FACEBOOK_API_VERSIONS } from '../../../../app/constants/facebook_api_versions';
import { getDataForSchemaImporter } from '../../../../app/package-designer/helpers/schema.helpers';
import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.directive('facebookSourceEditor', [
  '$rootScope',
  '$timeout',
  '$stateParams',
  '$injector',
  '$translate',
  'connectionsService',
  '$http',
  'ConnectionItemsResource',
  function (
    $rootScope,
    $timeout,
    $stateParams,
    $injector,
    $translate,
    connectionsService,
    $http,
    ConnectionItemsResource,
  ) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./facebook-source-editor.html'),

      replace: true,

      link($scope) {
        $scope.apiVersions = FACEBOOK_API_VERSIONS;
        $scope.levels = [];
        $scope.time_increments = [];
        $scope.date_presets = [];
        $scope.errors = [];

        $scope.filteringEditorOptions = {
          placeholder: "[{'field':'ad.effective_status','operator':'IN','value':['ARCHIVED','ACTIVE']}]",
          mode: 'application/json',
          autoCloseBrackets: true,
          matchBrackets: true,
        };

        markDeadApiVersions($scope.apiVersions);

        function markDeadApiVersions(apiVersions) {
          // get supported api versions from validation service
          _.each(apiVersions, function (apiVersion) {
            if (apiVersion.sunset_date && moment(apiVersion.sunset_date).diff(moment(), 'days') < 0) {
              apiVersion.dead = true;
            } else if (apiVersion.deprecation_date && moment(apiVersion.deprecation_date).diff(moment(), 'days') < 0) {
              apiVersion.deprecated = true;
            }
          });
        }

        function checkCurrentApiVersion(currentApiVersion) {
          if (!currentApiVersion) {
            $scope.apiErrorMessage = `Selected api version ${$scope.component.api_version} is not found.`;
            $scope.component.api_version = $scope.apiVersions[0].value;
          } else if (currentApiVersion.dead) {
            $translate('adwords-source-editor.form.errors.api_version', { api_version: currentApiVersion.text }).then(
              function (error) {
                $scope.errors.push(error);
              },
            );
          }
        }

        const convertFields = function (fields) {
          const availableFields = [];
          _.each(fields, function (field) {
            availableFields.push({
              name: field.id,
              alias: field.default_alias,
              data_type: field.data_type,
              category: field.category,
              pig_data_type: field.pig_data_type,
              request: field.request,
              response: field.response,
            });
          });
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, availableFields);
        };

        const handleError = function (res) {
          res.data && $scope.errors.push(res.error.error_message);
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, []);
        };

        const loadFields = function () {
          if ($scope.component.connection.type) {
            const schemaRequestData = {
              api_version: $scope.component.api_version,
              with_custom_fields: $scope.component.with_custom_fields,
            };

            if ($scope.component.with_custom_fields) {
              schemaRequestData['ad_accounts[]'] =
                $scope.component.report_on === 'all' ? ['any'] : $scope.component.ad_accounts;
            }

            ConnectionItemsResource.fieldsAsArray(
              $scope.component.connection.type,
              $scope.component.connection.id,
              schemaRequestData,
            ).subscribe(convertFields, handleError);
          }
        };

        initChangeListeners();

        function initChangeListeners() {
          const checkConnection = function (newChanges, oldChanges) {
            if (newChanges.length && newChanges[0].id) {
              if (!oldChanges[0] || oldChanges[0].id !== newChanges[0].id) {
                $scope.errors = [];
                loadFields();
              } else if ($scope.component.with_custom_fields) {
                if (
                  newChanges[1].length !== oldChanges[1].length ||
                  newChanges[2] !== oldChanges[2] ||
                  newChanges[3] !== oldChanges[3]
                ) {
                  $scope.errors = [];
                  loadFields();
                }
              } else if (newChanges[3] !== oldChanges[3]) {
                $scope.errors = [];
                loadFields();
              }
            } else if (newChanges && !oldChanges) {
              $scope.errors = [];
              loadFields();
            }
          };

          $scope.$watch(
            '[component.connection, component.ad_accounts, component.report_on, component.with_custom_fields]',
            checkConnection,
            true,
          );

          $scope.onApiVersionChange = function (apiVersion) {
            $scope.component.api_version = apiVersion;
            $scope.$broadcast('fbVersionChanged');
            if (apiVersion) {
              $scope.errors = [];
              setApiData(apiVersion);
              checkConnection($scope.component.connection);
              checkCurrentApiVersion(_.find($scope.apiVersions, { value: apiVersion }));
            }
          };

          $scope.onApiVersionChange($scope.component.api_version);

          $scope.onDateRangeChange = function (dateRange) {
            $scope.component.report_date_range_type = dateRange;

            if (dateRange !== 'CUSTOM_DATE') {
              $scope.component.report_date_range_min = '';
              $scope.component.report_date_range_max = '';
              $scope.component.manual_breakdown = 'Default';
            }
          };

          $scope.onLevelChange = function (level) {
            $scope.component.level = level;
          };

          $scope.onTimeIncrementChange = function (timeIncrement) {
            $scope.component.time_increment = timeIncrement;
          };

          const checkDayByDayBreakdown = function (breakdown) {
            if (breakdown === 'DayByDay') {
              $timeout(function () {
                $scope.component.time_increment = '1';
                $scope.isTimeIncrementDisabled = true;
              });
            } else {
              $scope.isTimeIncrementDisabled = false;
            }
          };

          $scope.$watch('component.manual_breakdown', checkDayByDayBreakdown);
        }

        function setApiData(apiVersion) {
          if (apiVersion) {
            $http
              .get(`${process.env.API_URL}/facebook/insights/${apiVersion.replace('.', '_')}.json`)
              .then(function (res) {
                const FACEBOOK_API = res.data;

                if (!checkFields(FACEBOOK_API.LEVELS, 'level', $scope.component.level)) {
                  $scope.component.level = FACEBOOK_API.LEVELS[0].value;
                }
                $scope.levels = FACEBOOK_API.LEVELS;

                if (!checkFields(FACEBOOK_API.TIME_INCREMENTS, 'time breakdown', $scope.component.time_increment)) {
                  $scope.component.time_increment = FACEBOOK_API.TIME_INCREMENTS[0].value;
                }
                $scope.time_increments = FACEBOOK_API.TIME_INCREMENTS;

                if (
                  $scope.component.report_date_range_type !== 'CUSTOM_DATE' &&
                  !checkFields(FACEBOOK_API.DATE_PRESETS, 'date range', $scope.component.report_date_range_type)
                ) {
                  $scope.component.report_date_range_type = FACEBOOK_API.DATE_PRESETS[0].value;
                }
                $scope.date_presets = FACEBOOK_API.DATE_PRESETS;

                $scope.date_presets.push({
                  name: 'Custom date',
                  value: 'CUSTOM_DATE',
                });
              });
          }
        }

        function checkFields(array, fieldName, value) {
          const field = _.find(array, { value });
          if (!field) {
            $translate('facebook_ads_insights_source_component.form.errors.missing_field', {
              name: fieldName,
              value,
            }).then(function (error) {
              $scope.errors.push(error);
            });
          }
          return !!field;
        }

        $scope.$on(EVENTS.DATA_PREVIEW_REFRESH, function (event, fields) {
          const schemaRequestData = getDataForSchemaImporter(
            { ...$scope.component, schema: { fields } },
            COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT,
            $stateParams.account_id,
          );

          if ($scope.component.connection.type) {
            ConnectionItemsResource.schema(
              $scope.component.connection.type,
              $scope.component.connection.id,
              schemaRequestData,
            ).subscribe(
              function (data) {
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, data);
              },
              function ({ error }) {
                if (error) {
                  $rootScope.$broadcast(EVENTS.DATA_PREVIEW_ERROR, error.error_message);
                }
              },
            );
          }
        });

        $scope.removeError = function (error) {
          const index = $scope.errors.indexOf(error);
          if (index > -1) $scope.errors.splice(index, 1);
        };
      },
    };
  },
]);
